import { Close } from '@mui/icons-material';
import {
  Fade,
  Typography,
  IconButton,
  Box,
  Modal,
  Link,
  FormControlLabel,
  Checkbox,
  CircularProgress,
  Alert
} from '@mui/material';
import { useState, useEffect } from 'react';
import MarkdownContent from '~/components/MarkdownContent';
import { getOrganizationTermsOfUse } from '~/services/modules/organizationTermsOfUse';
import { containerTermOfContract, modalContainer, termOfContract, termOfContractLabel } from '~/pages/Payment/styles';

interface ModalTermOfGaranteeProps {
  checkedTermOfGarantee: boolean;
  setCheckedTermOfGarantee: (value: boolean) => void;
  organizationId?: string | null;
}

export default function ModalTermOfGarantee({
  checkedTermOfGarantee,
  setCheckedTermOfGarantee,
  organizationId
}: ModalTermOfGaranteeProps) {
  const [open, setOpen] = useState(false);
  const [content, setContent] = useState<string>('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleOpen = () => setOpen(true);
  const handleClose = () => {
    setOpen(false);
    setError(null);
  };

  useEffect(() => {
    if (!open) return;
    setLoading(true);
    setError(null);
    getOrganizationTermsOfUse('Warranty', organizationId)
      .then(setContent)
      .catch((err) => {
        setError(err?.message ?? 'Não foi possível carregar os termos de garantia.');
        setContent('');
      })
      .finally(() => setLoading(false));
  }, [open, organizationId]);

  return (
    <>
      <Box sx={containerTermOfContract}>
        <FormControlLabel
          sx={{ marginRight: 0.4 }}
          control={
            <Checkbox
              checked={checkedTermOfGarantee}
              onChange={() => setCheckedTermOfGarantee(!checkedTermOfGarantee)}
            />
          }
          label={
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
              <Typography sx={termOfContractLabel}>Li e concordo com os </Typography>
              <Link sx={termOfContract} underline="hover" onClick={handleOpen}>
                termos de uso da garantia
              </Link>
            </Box>
          }
        />
        <Modal open={open} onClose={handleClose}>
          <Fade in={open}>
            <Box sx={{ ...modalContainer, position: 'relative' }}>
              <IconButton
                color="default"
                aria-label="close"
                onClick={handleClose}
                sx={{
                  position: 'absolute',
                  top: { xs: 8, sm: 16 },
                  right: { xs: 8, sm: 16 },
                  zIndex: 1
                }}
              >
                <Close />
              </IconButton>
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  padding: { xs: 1, sm: 2 },
                  paddingTop: { xs: 1, sm: 2 },
                  gap: 3
                }}
              >
                {loading && (
                  <Box sx={{ display: 'flex', justifyContent: 'center', py: 4 }}>
                    <CircularProgress />
                  </Box>
                )}
                {error && (
                  <Alert severity="error" onClose={() => setError(null)}>
                    {error}
                  </Alert>
                )}
                {!loading &&
                  !error &&
                  (content?.trim() ? (
                    <MarkdownContent content={content} />
                  ) : (
                    <Typography variant="body2" sx={{ color: 'rgba(255,255,255,0.7)' }}>
                      Conteúdo não disponível no momento.
                    </Typography>
                  ))}
              </Box>
            </Box>
          </Fade>
        </Modal>
      </Box>
    </>
  );
}
